/**
 * ui/services/sync-deletions.ts
 *
 * Deletions the player makes on this device (a draft, a replay, a reset),
 * announced so account sync can pass them on to their other devices. Sync
 * applying another device's deletion goes to the stores directly and isn't
 * announced here.
 */
import type { SyncKind } from '../../ports/account.js';

type DeletionListener = (kind: SyncKind, ids: string[]) => void;

const listeners = new Set<DeletionListener>();

export function recordDeletions(kind: SyncKind, ids: string[]): void {
  if (ids.length === 0) return;
  for (const listener of listeners) listener(kind, ids);
}

export function onDeletions(listener: DeletionListener): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
